module.exports = __webpack_public_path__ + "media/images/avatar_male1-03d9d18c6c3558ed41c8bb4e456e9eb7.png";